import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { SubscriptionForm } from "./SubscriptionForm";

export function SubscriptionFormDialog({ open, onOpenChange, onSaved, subscription }) {
  const isEdit = Boolean(subscription);
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl" data-testid="subscription-form-dialog">
        <DialogHeader>
          <DialogTitle>{isEdit ? "Edit Subscription" : "New Subscription"}</DialogTitle>
          <DialogDescription>
            Price and end date are calculated by the server as you fill this in.
          </DialogDescription>
        </DialogHeader>
        {open && (
          <SubscriptionForm
            subscription={subscription}
            active={open}
            onSaved={onSaved}
            onCancel={() => onOpenChange(false)}
          />
        )}
      </DialogContent>
    </Dialog>
  );
}
